module.exports = __webpack_public_path__ + "static/media/Group4.c0042198.png";